<template>
  <div>
    <img
      id="img"
      crossorigin="anonymous"
      style="width: auto; height: auto; max-width: 100%; max-height: 100%"
      :src="Img"
      alt=""
      srcset=""
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      Img: "",
    };
  },
  props: {
    imgUrl: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  async created() {
    let size = await this.getImageSize(this.imgUrl);
    var str = "?x-oss-process=style/"; //框正方形
    console.log(size.height, this.height, this.imgUrl, "-------------");
    if (size.height >= this.height) {
      str += "h_";
    } else if (size.height <= this.height) {
      str += "h_";
    } else {
      //正方形
      str += "w_";
    }
    // console.log(str, "str");
    this.Img = this.imgUrl + str + "w_" + this.width + "_h_" + this.height;
    // console.log(this.Img, "ret");
    // console.log(size);
  },
  methods: {
    getImageSize(url) {
      return new Promise(function (resolve, reject) {
        let image = new Image();
        image.onload = function () {
          console.log(image.width, image.height, "image");
          resolve({
            width: image.width,
            height: image.height,
          });
        };
        image.onerror = function () {
          reject(new Error("error"));
        };
        image.src = url;
      });
    },
  },
};
</script>
<style>
</style>